export default "/images/vendor/flag-icon-css/flags/1x1/eh.svg?905fdd0842d1597c4a27ad535ca30c49";